export default class ProductCartButtonHtml {
    constructor(id, dataId, dataName, productType, dataTx, img) {
        this._id = id;
        this._dataId = dataId;
        this._dataName = dataName;
        this._productType = productType;
        this._dataTx = dataTx || '';
        this._img = img;
    }

    toString() {
        // eslint-disable-next-line no-undef
        const $globalConfig = config;

        let img = '';

        if(this._image && this._image.identifier && this._image.identifier !== '') {
            img = $globalConfig.urls.mediaFilesURL + this._img.WEBXS;
        } 

        return `
            <button id="${this._id}" data-img="${img}" data-id="${this._dataId}" data-name="${this._dataName}" data-type="${this._productType}" data-tx="${this._dataTx}" data-value="1"
                class="cta-button cta-button--primary 
                rfct-button--shopping_cart cta-button--product-cart
                cta-button--online-cataloge
                action-card__shop-button" 
                type="" aria-label="Secondary" button=""
            >
                ${$globalConfig.textResources.productCatalogConnectorConfig.labelOffers}
                <span class="cta-button__icon cta-button__icon--right icon icon-shopping-list">
                    
                </span>
            </button>
        `;
    }
}
